import { $t } from '@/i18n';
import Vue from 'vue';
import { cloneDeep, isEqual } from 'lodash';
import { walkLayout } from '@tencent/ui-core/lib/utils';
import { UC_TAG_FROM_TEMPLATE, UC_TAG_SHADOWED } from './consts';
/**
 * 从 layout 现场派生模板声明的数据源（按 templateId 去重，跨模板同 id 先出现的保留）。
 *
 * 不进入 scopedSlots：作用域插槽是独立子页面片，由它自己的 renderer 派生。
 */
export function deriveTemplateSources(layout, getTemplate) {
    if (!layout)
        return [];
    const seenTemplates = new Set();
    const seenSourceIds = new Set();
    const sources = [];
    walkLayout(layout, ({ layout: node }) => {
        const { templateId } = node;
        if (!templateId || seenTemplates.has(templateId))
            return;
        seenTemplates.add(templateId);
        const tplSources = getTemplate(templateId)?.xySources;
        if (!tplSources?.length)
            return;
        for (const source of tplSources) {
            if (!source?.id || seenSourceIds.has(source.id))
                continue;
            seenSourceIds.add(source.id);
            sources.push(cloneDeep(source));
        }
    });
    return sources;
}
/**
 * 把模板数据源注入进内存 pagelet.xySources（打 uc:fromTemplate，不落盘）。
 *
 * 撞名时模板为准：页面原件备份到注入项的 uc:shadowedSource，保存时还原。
 */
export function syncTemplateSourcesToPagelet(pagelet, sources) {
    if (!pagelet)
        return;
    const existing = (pagelet.xySources || []);
    const pageOwned = existing.filter(s => !s[UC_TAG_FROM_TEMPLATE]);
    const pageById = new Map(pageOwned.map(s => [s.id, s]));
    const injected = sources
        .filter(s => s?.id)
        .map((source) => {
        const shadowed = pageById.get(source.id);
        if (shadowed) {
            pageById.delete(source.id);
            console.warn($t('k_e9524cc', { arg_0: source.id }));
        }
        const next = {
            ...cloneDeep(source),
            [UC_TAG_FROM_TEMPLATE]: true,
            'uc:tag': $t('k_40ead0fd'),
        };
        if (shadowed) {
            // 备份时剥掉可能残留的注入标记，只留页面真正拥有的配置
            const { [UC_TAG_FROM_TEMPLATE]: _t, [UC_TAG_SHADOWED]: _s, ...raw } = shadowed;
            next[UC_TAG_SHADOWED] = cloneDeep(raw);
        }
        return next;
    });
    const nextSources = [...pageById.values(), ...injected];
    if (isEqual(existing, nextSources))
        return;
    Vue.set(pagelet, 'xySources', nextSources);
}
